import {HttpHeaders} from "@angular/common/http";

export abstract class BaseRestService {
    public getToken(): string {
        return localStorage.getItem('restApiToken');
    }

    protected get authHeaders(): HttpHeaders{
        const token = this.getToken();
        return new HttpHeaders({
            'x-api-key': `${token}`,
            'x-api-version': '1.0'
        });
    } 

    protected get authHeadersV2(): HttpHeaders {
        const token = this.getToken();
        return new HttpHeaders({
            'x-api-key': `${token}`,
            'x-api-version': '2.0'
        });
    }

  }